(function () {
    'use strict';

    function initBlogLoadMore(results) {
        var isLoading = false;
        var requestController = null;

        if (typeof window.fetch !== 'function') {
            return;
        }

        results.addEventListener('click', function (event) {
            var button = event.target.closest('[data-load-more]');
            var items = results.querySelector('[data-load-more-items]');

            if (!button || !items || isLoading) {
                return;
            }

            event.preventDefault();
            isLoading = true;
            button.classList.add('is-loading');
            button.setAttribute('aria-disabled', 'true');
            results.setAttribute('aria-busy', 'true');

            if (requestController) {
                requestController.abort();
            }

            requestController = typeof AbortController === 'function'
                ? new AbortController()
                : null;

            window.fetch(button.href, {
                method: 'GET',
                credentials: 'same-origin',
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
                signal: requestController ? requestController.signal : undefined
            })
                .then(function (response) {
                    if (!response.ok) {
                        throw new Error('Request failed');
                    }

                    return response.text();
                })
                .then(function (html) {
                    var nextDocument = new DOMParser().parseFromString(html, 'text/html');
                    var nextResults = nextDocument.querySelector('[data-blog-results]');
                    var nextItems = nextResults
                        ? nextResults.querySelector('[data-load-more-items]')
                        : null;

                    if (!nextResults || !nextItems) {
                        throw new Error('Blog results not found');
                    }

                    Array.prototype.slice.call(nextItems.children).forEach(function (item) {
                        items.appendChild(item);
                    });

                    var currentPagination = results.querySelector('.pagination');
                    var nextPagination = nextResults.querySelector('.pagination');
                    var currentControls = results.querySelector('[data-load-more-controls]');
                    var nextControls = nextResults.querySelector('[data-load-more-controls]');

                    if (currentPagination && nextPagination) {
                        currentPagination.replaceWith(nextPagination);
                    } else if (currentPagination) {
                        currentPagination.remove();
                    }

                    if (currentControls && nextControls) {
                        currentControls.replaceWith(nextControls);
                    } else if (currentControls) {
                        currentControls.remove();
                    }
                })
                .catch(function (error) {
                    if (error.name !== 'AbortError') {
                        window.location.assign(button.href);
                    }
                })
                .finally(function () {
                    isLoading = false;
                    button.classList.remove('is-loading');
                    button.removeAttribute('aria-disabled');
                    results.removeAttribute('aria-busy');
                });
        });

        window.addEventListener('pageshow', function () {
            isLoading = false;
            results.removeAttribute('aria-busy');
        });
    }

    function init() {
        document.querySelectorAll('[data-blog-results]').forEach(initBlogLoadMore);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}());
